var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ErrorHandler, } from '@wix/fe-essentials/error-handler';
import { getArtifactId, getFullArtifactId } from '../utils';
export var createErrorHandler = function (_a) {
    var biLoggerOrFactory = _a.biLoggerOrFactory, initI18n = _a.initI18n, createErrorMonitor = _a.createErrorMonitor, language = _a.language, appDefId = _a.appDefId;
    return new ErrorHandler({
        environment: {
            artifactId: getArtifactId(),
            fullArtifactId: getFullArtifactId(),
        },
        biLoggerOrFactory: biLoggerOrFactory,
        createErrorMonitor: createErrorMonitor !== null && createErrorMonitor !== void 0 ? createErrorMonitor : (function () { return ({
            captureException: function () { },
        }); }),
        createI18n: function (options) {
            return initI18n(__assign(__assign({}, options), { locale: language }));
        },
        biDefaultsOverrides: {
            hostingEnvironment: 'editor',
            app_id: appDefId,
        },
    });
};
//# sourceMappingURL=createErrorHandler.js.map